import { useState, useCallback } from 'react';

export default function useLoginForm(loginFn, onSuccess) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginFn(email, password);
      onSuccess();
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string') {
        setError(detail);
      } else if (Array.isArray(detail)) {
        setError(detail.map(item => item.msg || JSON.stringify(item)).join(' '));
      } else {
        setError('Login failed');
      }
    } finally {
      setLoading(false);
    }
  }, [email, password, loginFn, onSuccess]);

  return { email, setEmail, password, setPassword, error, loading, submit };
}
